import {Component, computed, inject, input, Signal} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NavBarComponent, NavButton, SvgSpriteIcon} from '@selpia/shared/ui';
import {AppConfigFacade} from '@selpia/app-config/data-access';
import {FeatureNotificationsComponent} from '@selpia/options/feature-notifications';

@Component({
  selector: 'lib-feature-nav',
  imports: [CommonModule, NavBarComponent, FeatureNotificationsComponent],
  templateUrl: './feature-nav.component.html',
  styleUrl: './feature-nav.component.scss',
})
export class FeatureNavComponent {
  readonly #appConfigFacade = inject(AppConfigFacade);

  readonly navButtons = input<NavButton[]>();

  protected readonly SvgSpriteIcon = SvgSpriteIcon;

  protected readonly dashboardTitle: Signal<string> = this.#appConfigFacade.dashboardTitle;

  protected readonly allButtons: Signal<NavButton[]> = computed(() => {
    const homeButton = {
      icon: SvgSpriteIcon.Dashboard,
      label: this.dashboardTitle(),
      target: '/',
      options: {exact: true},
    };
    const otherButtons = this.navButtons();

    return otherButtons ? [homeButton, ...otherButtons] : [homeButton];
  });
}
